exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".timestamp-list-area[data-v-4a19710a]{overflow-y:auto;height:40vh}", ""]);

// exports
